// extracted by mini-css-extract-plugin
export var externalLink = "_cx-0";
export var internalLinkLabel = "_cx-1";